import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: {
    userName: '',
    userId: '',
    accessToken: '',
  },
  userDetail: {},
  isSucessfullLogin: false,
  isDrawerOpen: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    login: (state, { payload }) => {
      state.data.userName = payload.userName;
      state.data.userId = payload.userId;
      state.data.accessToken = payload.accessToken;
    },
    userDetail: (state, { payload }) => {
      state.userDetail = payload.userDetail;
    },
    isSucessfullLogin: (state, { payload }) => {
      state.isSucessfullLogin = payload.isSucessfullLogin;
    },
    isDrawerOpen: (state, { payload }) => {
      state.isDrawerOpen = payload.isDrawerOpen;
    },
  },
});

export const { login, userDetail, isSucessfullLogin, isDrawerOpen } =
  userSlice.actions;

export const selectUser = ({ user }) => user;

export const selectUserDetail = ({ user }) => user.userDetail;

export const selectIsSucessfullLogin = ({ user }) => user.isSucessfullLogin;

export const selectIsDrawerOpen = ({ user }) => user.isDrawerOpen;

export default userSlice.reducer;